import URLs from '~/enums/URLs';
import { useTranslation } from '@sunbit-dev/translations';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { UseSteps } from './models';

export const useSteps: UseSteps = () => {
  const { t } = useTranslation('application_layout');
  const { pathname } = useLocation();

  const titles = t('steps_titles');

  return useMemo(() => {
    const stepsByPath = {
      [URLs.CustomerDetails]: { position: 1, title: titles['customer_details'] },
      [URLs.ChooseYourPlan]: { position: 2, title: titles['choose_your_plan'] },
      [URLs.PaymentDetails]: { position: 3, title: titles['payment_details'] },
      [URLs.Agreement]: { position: 4, title: titles['agreement'] },
    };

    const exactPathName = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

    const currentStepPosition = stepsByPath[exactPathName as URLs]?.position;
    return {
      steps: Object.values(stepsByPath),
      currentStepPosition,
      showStepper: !!currentStepPosition,
    };
  }, [pathname]);
};
